import styled from 'styled-components';
import { IonPage } from '@ionic/react';

export const IonPageWrapper = styled(IonPage)`
`;